import { Ratings } from '../entities';

export type PriceTargetFields = Partial<
  Pick<Ratings, 'adjusted_pt_current' | 'adjusted_pt_prior' | 'pt_current' | 'pt_prior'>
>;

type PriceTargetValue = string | number | null | undefined;

const hasPriceTarget = (value: PriceTargetValue): boolean => {
  if (value === null || value === undefined || String(value).trim() === '') return false;
  const numeric = Number(value);
  return Number.isFinite(numeric) && numeric !== 0;
};

const toPriceTarget = (value: PriceTargetValue): string =>
  value === null || value === undefined ? '' : String(value);

// A row uses one basis for both targets: the API's split-adjusted pair when the adjusted
// current target is present, else the raw pair. Split adjustment happens on the backend
// only; never restate targets here.
const isAdjusted = (rating?: PriceTargetFields | null): boolean => hasPriceTarget(rating?.adjusted_pt_current);

export const getPriceTarget = (rating?: PriceTargetFields | null): string =>
  toPriceTarget(isAdjusted(rating) ? rating?.adjusted_pt_current : rating?.pt_current);

export const getPriorPriceTarget = (rating?: PriceTargetFields | null): string =>
  toPriceTarget(isAdjusted(rating) ? rating?.adjusted_pt_prior : rating?.pt_prior);
